import { motion } from 'framer-motion'

interface SpeedGaugeProps {
  value: number // 0-100
  label?: string
}

export function SpeedGauge({ value, label = 'Speed' }: SpeedGaugeProps) {
  const rotation = value * 1.8 - 90 // Maps 0-100 to -90 to 90 degrees

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="relative w-40 h-40">
        {/* Background circle */}
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 200 200">
          {/* Gauge background */}
          <circle
            cx="100"
            cy="100"
            r="90"
            fill="none"
            stroke="rgba(27, 38, 49, 0.8)"
            strokeWidth="2"
          />

          {/* Gauge arc */}
          <path
            d="M 20 100 A 80 80 0 0 1 180 100"
            fill="none"
            stroke="url(#gaugeGradient)"
            strokeWidth="8"
            strokeLinecap="round"
          />

          {/* Center circle */}
          <circle cx="100" cy="100" r="12" fill="#00D9A5" />

          {/* Gradient definition */}
          <defs>
            <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#00D9A5" />
              <stop offset="50%" stopColor="#FFE135" />
              <stop offset="100%" stopColor="#FF6F61" />
            </linearGradient>
          </defs>
        </svg>

        {/* Needle */}
        <motion.div
          animate={{ rotate: rotation }}
          transition={{ type: 'spring', stiffness: 100, damping: 15 }}
          className="absolute inset-0 flex items-center justify-center origin-center"
        >
          <div className="w-2 h-16 bg-gradient-to-b from-tropical-green to-transparent rounded-full" />
        </motion.div>

        {/* Value display */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <motion.div
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ duration: 0.5, repeat: Infinity }}
            className="text-3xl font-fredoka font-700 text-tropical-green"
          >
            {Math.round(value)}
          </motion.div>
          <div className="text-xs text-gray-400 font-quicksand">{label}</div>
        </div>
      </div>
    </div>
  )
}
